import {
  DEGEN_MIN_LEVERAGE,
  NORMAL_MIN_LEVERAGE,
} from '@ui/constants/uiConfig';
import { useGetPairMaxTpRatios } from '@ui/services/contract/hooks/TradingConfigFacet/useGetPairMaxTpRatios/useGetPairMaxTpRatios';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

export const useMinLeverage = ({ position }: { position: Position }) => {
  const { data: maxTpRatios } = useGetPairMaxTpRatios({
    pairBase: position.pair.address,
  });
  const firstMaxTpRatio = maxTpRatios?.[0];

  const firstMaxTpRatioLeverage =
    isNil(firstMaxTpRatio?.leverage) ||
    firstMaxTpRatio?.leverage < DEGEN_MIN_LEVERAGE
      ? DEGEN_MIN_LEVERAGE
      : firstMaxTpRatio?.leverage;

  return useMemo(
    () =>
      position.pair.isDegenPair ? firstMaxTpRatioLeverage : NORMAL_MIN_LEVERAGE,
    [firstMaxTpRatioLeverage, position.pair.isDegenPair],
  );
};
